import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4643b719"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-user-container"
};
import { onMounted, ref } from 'vue';
// import { Search, Refresh } from '@element-plus/icons-vue'

// import usePagination from '@/hooks/usePagination'
// import { indexMethod } from '@/utils/indexMethod'
import { getApplinkOnlineClinics, getApplinkAllClinics } from '@/api/sys';
import { useRoute } from 'vue-router';

// const { currentPage, total, pageSize, setCurrentPage, setTotal } = usePagination()

export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const loading = ref(false);

    // const keyword = ref('')
    const _getApplinkOnlineClinics = async () => {
      loading.value = true;
      const res = await getApplinkOnlineClinics({
        // currentPage: currentPage.value,
        // pageSize: pageSize.value,
        // keyword: keyword.value
      });
      tableData.value = res;
      // setTotal(res.total)
      loading.value = false;
    };
    const _getApplinkAllClinics = async () => {
      loading.value = true;
      const res = await getApplinkAllClinics({
        // currentPage: currentPage.value,
        // pageSize: pageSize.value,
        // keyword: keyword.value
      });
      tableData.value = res;
      // setTotal(res.total)
      loading.value = false;
    };
    const route = useRoute();
    onMounted(() => {
      if (route.query.isOnline === 'true') {
        _getApplinkOnlineClinics();
      } else {
        _getApplinkAllClinics();
      }
    });

    // const handleCurrentChange = (e) => {
    //   setCurrentPage(e)
    //   _getApplinkOnlineClinics()
    // }

    // const handleRefresh = async () => {
    //   setCurrentPage(1)
    //   keyword.value = ''
    //   _getApplinkOnlineClinics()
    // }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            "min-width": "20"
          }), _createVNode(_component_el_table_column, {
            label: "诊所id",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            label: "诊所名称",
            prop: "name"
          }), _unref(route).query.isOnline == 'true' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "当日请求总数",
            prop: "requestCount"
          })) : _createCommentVNode("", true), _unref(route).query.isOnline == 'false' ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "在线状态",
            prop: "status"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("div", {
              style: _normalizeStyle({
                color: row.state === 1 ? 'green' : 'red'
              })
            }, _toDisplayString(row.state === 1 ? '在线' : '离线'), 5)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]])]),
        _: 1
      })]);
    };
  }
};